<template>
	<v-select v-model="seleccionado" :items="metodosPago" 
		label="Elija método de pago"  
		solo flat item-value="id_sii" 
		item-text="nombre"
		return-object
		outlined
		v-bind="$attrs"
		@change="onInput"
	>
		<!-- <template v-slot:prepend-inner>
			<v-btn
				icon
				@click.stop="$store.dispatch('app/getConfig')"
				:loading="$store.getters['app/loading']"
			>
				<v-icon>refresh</v-icon>
			</v-btn>
		</template> -->
	</v-select>
</template>
<script>

export default {
	props: {
		
	},
	computed: {
		metodosPago() {
			return this.$store.getters['app/metodosPago'].sort((a, b) => a.orden - b.orden);
		},
	},
	data: () => ({
		seleccionado: null,
	}),
	methods: {
		onInput(){
			this.$emit('input', this.seleccionado)
			this.$emit('aplicar-config')
		}
		,reset(){
			this.seleccionado = null;
			this.$emit('input', this.seleccionado)
		}
	},
	mounted(){
		
	},

};


</script>